export const TERMINAL_GROUPS = [
  { value: "none", label: "No Restriction" },
  {
    value: "green",
    label: "Green (Nongsa Terminal) — earliest 09:00 WIB",
    earliestTeeTime: "09:00",
  },
  {
    value: "pink",
    label: "Pink Terminal — earliest 09:30 WIB",
    earliestTeeTime: "09:30",
  },
];

export function getEarliestTeeTime(terminalGroup) {
  return TERMINAL_GROUPS.find((g) => g.value === terminalGroup)?.earliestTeeTime || null;
}